export default __webpack_public_path__ + "static/4-b82a231d05cc405736037a3a3d6d860d.jpg";